var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('addHeader',{attrs:{"title":_vm.$t('App Store'),"description":_vm.$t('From Here You Can Download Applications For The System')}}),_c('div',{staticClass:"row"},[_c('applicationCard',{staticClass:"col-md-4"})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }